// extracted by mini-css-extract-plugin
export default {"eventItem":"eventItem_eventItem__P5KVc","eventInfo":"eventItem_eventInfo__CC0IA"};